/**
 * Tooltip library
 */

var AwesomeTooltip = function (args) {
    'use strict';
    var self = this;
    var $ = jQuery;
    var $container = $(args.container); // parent container
    var $content = $(args.content); // tooltip content
    var direction = args.direction || 'top'; // tooltip direction
    var data = args.data; // variables to replace tags in template
    self.viewport = $(args.viewport || '#wpbody');
    self.args = args;

    // replace tags in template with values from [data] variables
    self.replace_tags = function () {
        var html = $content.prop('outerHTML');
        $.each(data, function (key, value) {
            html = html.replace_all('{{' + key + '}}', value);
        });
        return html;
    };

    self.show_field = function ($tooltip) {
        var blocks = model.get('styles.' + model.get('layout'));

        $('.model-field', $tooltip).hide();
        $.each(blocks, function (key, value) {
            if(value === null){
                return;
            }
            $('.' + key, $tooltip).show(); // show field block
        });
    };

    // create tooltip
    self.open = function () {
        /* jshint multistr: true */
        var template = '<div class="a-tooltip-wrapper at-transition at-transition-fast" data-field="##field##">\
            <div class="a-tooltip a-tooltip-arrow">\
            <div class="a-tooltip-content">\
            ##content##\
            </div>\
            </div>\
            </div>';
        var html = self.replace_tags();

        html = template.replace(/##content##/g, html);
        html = html.replace(/##field##/g, data.field_name);
        var $tooltip = $(html);

        $container.append($tooltip);

        if(typeof window.model !== 'undefined'){
            self.show_field($tooltip);
        }

        if(self.args.center){
            var left = (aet_panel.width() - $tooltip.width())/2 - 30;
            $tooltip.css('left', left + 'px');
        }

        if($tooltip.length === 0){
            return;
        }

        $tooltip.addClass('tooltip-' + direction);
    };

    // destroy tooltip
    self.destroy = function () {
        $container.find('.a-tooltip-wrapper').remove();
    };

    // init tooltip
    self.init = function () {
        self.open();
    };
};